
import $ from 'jquery';
import util from 'util/Util';


class NumericUtil {
    transform(model) {
        //plain number ==> model.get('text')
        if(model.get('text') === '' || model.get('text') === undefined){
            model.set('numericText', model.get('text'), { silent: true });
            return;
        }        

        let textRaw = model.get('text');
        let text = Number(model.get('text'));

        if (!text){ 
            //Manage scenario when text value cannot be parsed to number
            text = 0;
        }

        const textSplitted = textRaw.toString().split('-');

        if (textSplitted.length > 1 && textSplitted[0].length > 0){
            text = Number('-' + textSplitted[1]);
        }

        //buffer
        let numericText = text.toString();

        //properties        
        const paddingEnabled = util.isTrue(model.get('paddingEnabled'));

        if (paddingEnabled){
            model.set('symbol', '', { silent: true });
            model.set('decimalLength', '0', { silent: true });
            model.set('decimalSeparator', '.', { silent: true });
            model.set('thousandsSeparator', '', { silent: true });
            model.set('allowNegative', 'false', { silent: true });
        }

        const leadingZero = util.isTrue(model.get('showLeadingZero'));
        const currencySymbol = model.get('symbol');
        const decimals = util.extractNum(model.get('decimalLength'));
        const thousandsSeparator = model.get('thousandsSeparator');
        const decimalSeparator = model.get('decimalSeparator');
        
        const paddingAmount = util.extractNum(model.get('paddingAmmount'));
        const paddingAlignment = model.get('paddingAlignment');
        const allowNegative = util.isTrue(model.get('allowNegative'));

        if (!allowNegative) {
            if (text < 0) {
                text = text * -1;
            }
        }

        // Validate min and max value
        text = this.validateMinMax(text, util.extractNum(model.get('min')), util.extractNum(model.get('max')));

        if (paddingEnabled) {
            numericText = this.padding_numeric(parseInt(text).toString(), paddingAmount, '0', paddingAlignment.toLowerCase() === 'trailing');
        } else {
            if (decimals >= 0) {
                numericText = text.toFixed(decimals);
                text = numericText;
                //change dot per comma since there is just two separators.
                if (decimalSeparator !== this.whatDecimalSeparator()) {
                    numericText = numericText.toString().replace(this.whatDecimalSeparator(), decimalSeparator);
                }
            }else{
                numericText = parseInt(text);
                text = numericText;
            }
            
            if (text >= 1000) {
                let numberSplit = numericText.split(decimalSeparator);
                let intPart = numericText;
                if (numberSplit.length === 2){
                    intPart = numberSplit[0];
                    numericText = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, (thousandsSeparator === 'None' || typeof thousandsSeparator === 'undefined' ? '' : thousandsSeparator));
                    numericText = numericText + decimalSeparator + numberSplit[1];
                }else{
                    numericText = numericText.replace(/\B(?=(\d{3})+(?!\d))/g, (thousandsSeparator === 'None' || typeof thousandsSeparator === 'undefined' ? '' : thousandsSeparator));
                }
            }

            if (currencySymbol !== '') {
                numericText = currencySymbol + numericText;
            }
        }

        model.set('numericText', numericText, { silent: true });        
        model.set('text', text, { silent: true });
    }
	
	whatDecimalSeparator() {
        const def = ".";

        try {
            let n = 1.1;
            n = n.toLocaleString().substring(1, 2);
            return n;
        }
        catch (e) { }

        return def;
    }

    // TODO: should not be static, but cannot do the test    
    validateMinMax(value, min, max) {
        if (value < min) {
            return Number(min);
        }
        else if (value > max) {
            return max;
        }

        return value;
    }

    padding_numeric(number, paddingAmount, paddingCharacter, paddingAlignment) {
	    return number.length < paddingAmount ? this.padding_numeric((paddingAlignment ? "" : paddingCharacter) + number + (paddingAlignment ? paddingCharacter : ""), paddingAmount, paddingCharacter, paddingAlignment) : number
    }
}

const numericUtil = new NumericUtil();
export default numericUtil;